// extracted by mini-css-extract-plugin
export default {"wrap":"Select_wrap__wBJn-","select":"Select_select__aeuTF","compact":"Select_compact__LoZJ9","carret":"Select_carret__VslDL","compactCarret":"Select_compactCarret__8nPk6"};